module.exports = __webpack_public_path__ + "static/media/TreeImage.1c577116.png";